import { useTranslation } from "@refinedev/core"
import { HTMLAttributes } from "react"
import { FaInfo } from "react-icons/fa6"

export interface GoogleServicesPopupProps extends HTMLAttributes<HTMLDivElement> {
    update?: boolean
}

export const GoogleServicesPopup = ({ update = false, onClick, className, ...rest }: GoogleServicesPopupProps) => {
    const { translate } = useTranslation()

    return <div className={`flex flex-col items-center ${className ?? ''}`} {...rest}>
        <div className="card shadow-lg  max-w-md">
            <div className="group card-title gap-4  items-center text-base-100 bg-secondary p-4 pl-8 relative overflow-hidden">
                <FaInfo className="w-12 h-12" />
                <h1 className="text-2xl uppercase font-bold w-64">Necesitamos acceder a tu caledario!</h1>
                <img className="absolute bottom-0 right-0 w-24 -mb-2 -mr-2 group-hover:-mb-1 group-hover:-mr-1 transition-all" src="/img/hachi-corner.png" alt="" />
            </div>
            <div className="card-body bg-base-200">
                {/* <a className="link" href={emergencyEvent.htmlLink!}>Link del evento</a> */}
                <fieldset className="fieldset">
                    <legend>Google Services Access</legend>
                    <h3 className="text-2xl">Muchas de las funcionalidades de la <strong>Hachimind</strong> requieren acceso a tus servicios de Google</h3>
                    {/* <span className="font-normal text-sm">{`${date.to(dayjs(emergencyEvent.start?.dateTime))},`} <strong>{`${dayjs(emergencyEvent.start?.dateTime).format('HH:mm')} - ${dayjs(emergencyEvent.end?.dateTime).format('HH:mm')}`}</strong></span> */}
                </fieldset>
                <fieldset className="fieldset my-2">
                    <button className="btn btn-primary" onClick={(e) => onClick?.(e as any)}>
                        {translate("common.google.new-connect")}
                    </button>
                    <div className="label">
                        {/* <span className="label-text-alt cursor-copy tooltip" data-tip={copy} onClick={copyText}>{meetLink}</span> */}
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
}